<template>
  <div>
    <Header page="manager_users"/>
    <div id="listUser" class="list-user list-files">
      <div class="container">
        <div class="list-user--table">
          <div class="header-table">
            <b-row>
              <b-col md="4">
                <h2 class="heading2">
                  従業員数 :
                  <span>{{totalEmployee}}</span>
                </h2>
              </b-col>
              <b-col md="8">
                <div class="filter-wrapper">
                  <b-form inline class="float-md-right">
                    <label class="mr-sm-2" for="sort-data">並び替え:</label>
                    <b-form-select
                        id="sort-data"
                        class="mb-2 mr-sm-2 mb-sm-0 input-form"
                        @change="filterDisplay"
                        v-model="paginations.sortBy"
                        :options="[
                            { text: '名前', value: 'name' },
                            { text: '日にち', value: 'created_at' },
                            { text: 'Eメール', value: 'email' },
                            { text: '役割', value: 'role_id' }
                        ]"
                    ></b-form-select>
                    <b-form-select
                        id="sort-order-data"
                        class="mb-2 mr-sm-2 mb-sm-0 input-form"
                        @change="filterDisplay"
                        v-model="paginations.sortOrder"
                        :options="[
                            { text: 'Desc', value: 'desc' },
                            { text: 'Asc', value: 'asc' }
                        ]"
                    ></b-form-select>
                    <b-form-select
                        id="per-page"
                        class="mb-2 mr-sm-2 mb-sm-0 input-form"
                        @change="filterDisplay"
                        v-model="paginations.perPage"
                        :options="[
                            { text: '10', value: 10 },
                            { text: '50', value: 50 },
                            { text: '100', value: 75 },
                        ]"
                    ></b-form-select>
                    <b-form-input
                        id="sort-order-data"
                        class="input-form"
                        type="search"
                        placeholder="Search"
                        v-model="paginations.searchQuery"
                        @input="onSearch(paginations.searchQuery)"
                    ></b-form-input>
                    <b-form-checkbox
                      stacked
                      class="mts-2 ml-2"
                      v-model="paginations.statusQuery"
                      @change="onSearch(paginations.statusQuery)"
                      :value="1"
                      :unchecked-value="0"
                    > アーカイブ従業員</b-form-checkbox>
                </b-form>
                </div>
              </b-col>
            </b-row>
          </div>
          <div class="body-table">
            <table class="table table-csUser">
              <thead>
                <tr>
                  <th scope="col" class="w-30">名前</th>
                  <th scope="col" class="hidden-mb w-15">所属</th>
                  <th scope="col" class="hidden-mb w-10">ロール</th>
                  <th scope="col" class="w-15">電話番号</th>
                  <th scope="col" class="hidden-mb w-20">メールアドレス</th>
                  <th scope="col" class="w-10"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="listUser in users" v-bind:key="listUser.id" @dblclick="detailUser(listUser.id)" title="ダブルタップして開きます">
                  <th scope="row" class="table-name w-30">
                    <div class="table-name--box files">
                      <div class="favorite">
                        <img :src="listUser.avatar" alt="" class="avt-folder" />
                      </div>
                      <div class="info admin-name">
                        <h4 class="name d-none d-lg-block">{{truncate(listUser.name,20,'...')}}</h4>
                        <h4 class="name d-block d-lg-none">{{truncate(listUser.name,8,'...')}}</h4>
                        <span class="user-id id">コード: {{truncate(listUser.employee_code,10,'...')}}</span>
                      </div>
                    </div>
                  </th>
                  <td class="table-department hidden-mb w-15">{{truncate(listUser.position === 'null' ?'':listUser.position,6,'...')}}</td>
                  <td class="table-role hidden-mb w-10">{{convertName(role(listUser.role_id))}}</td>
                  <td class="table-phone w-15">{{truncate(listUser.phone === 'null' ?'': listUser.phone,12,'...')}}</td>
                  <td class="table-email hidden-mb w-20">{{truncate(listUser.email,25,'...')}}</td>
                  <td class="table-action wider-click text-right w-10">
                    <b-dropdown class="dropdownAction dropdown-files dropdown-vendor" variant="link"  toggle-class="text-decoration-none" no-caret>
                      <template v-slot:button-content>
                        <i class="icon-i-dot"></i>
                      </template>
                      <b-dropdown-item @click="detailUser(listUser.id)">
                        <i class="icon-i-eyes"></i>
                        <span>開く</span>
                      </b-dropdown-item>
                       <b-dropdown-item v-if="showAction(listUser.role_id) && listUser.status == 0"  @click="editUser(listUser.id)">
                        <i class="icon-i-edit"></i>
                        <span>編集</span>
                      </b-dropdown-item>
                       <b-dropdown-item v-if="showAction(listUser.role_id)" @click="showModalDelete(listUser.id)" >
                        <i class="icon-i-trash"></i>
                        <span>削除</span>
                      </b-dropdown-item>
                      <b-dropdown-item v-if="showAction(listUser.role_id) && listUser.status == 0" @click="showmodalArchive(listUser.id)" >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-archive ml-2" viewBox="0 0 16 16">
                          <path d="M0 2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v7.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 12.5V5a1 1 0 0 1-1-1V2zm2 3v7.5A1.5 1.5 0 0 0 3.5 14h9a1.5 1.5 0 0 0 1.5-1.5V5H2zm13-3H1v2h14V2zM5 7.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                        <span class="ml-12">アーカイブ</span>
                      </b-dropdown-item>
                      <b-dropdown-item v-if="showAction(listUser.role_id) && listUser.status == 1" @click="setActive(listUser.id)" >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-archive ml-2" viewBox="0 0 16 16">
                          <path d="M0 2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v7.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 12.5V5a1 1 0 0 1-1-1V2zm2 3v7.5A1.5 1.5 0 0 0 3.5 14h9a1.5 1.5 0 0 0 1.5-1.5V5H2zm13-3H1v2h14V2zM5 7.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                        <span class="ml-12">アーカイブ解除</span>
                      </b-dropdown-item>
                    </b-dropdown>
                  </td>
                </tr>
              </tbody>
            </table>
            <nav aria-label="Page navigation" v-if="showPage">
              <ul class="pagination">
                <li class="page-item" :class="hasPrev"><a class="page-link prev" @click.prevent="changePage(paginations.page_index-1)"><i class="icon-i-prev"></i></a></li>
                <li class="page-item" v-if="hasPagination" v-for="(page,index) in pageNumber" v-bind:key="index"><a class="page-link" v-bind:class="{'active': page.value === paginations.page_index}" @click.prevent="changePage(page.value)">{{page.text}}</a></li>
                <li class="page-item" :class="hasNext"><a class="page-link next" @click.prevent="changePage(paginations.page_index+1)"><i class="icon-i-next"></i></a></li>
              </ul>
            </nav>
          </div>
        </div>
        <div class="buttonFixed">
          <button class="btn btn-circle btnpulse btn-primary btn-addUser" @click="showModalAdd">
            <!-- <i class="icon-i-adduser fs-28"></i> -->
            <svg id="Group_9879" data-name="Group 9879" xmlns="http://www.w3.org/2000/svg" width="28.184" height="28.184" viewBox="0 0 28.184 28.184">
              <g id="Group_9876" data-name="Group 9876">
                <g id="Group_9875" data-name="Group 9875">
                  <path id="Path_8698" data-name="Path 8698" d="M20.234,14.142a14.324,14.324,0,0,0-1.657-.665,7.486,7.486,0,1,0-8.964,0A14.32,14.32,0,0,0,.072,24.151a3.345,3.345,0,0,0,3.27,4.034H16.9a1.1,1.1,0,1,0,0-2.2H3.341a1.119,1.119,0,0,1-.881-.419,1.15,1.15,0,0,1-.233-.964A12.164,12.164,0,0,1,13.8,14.967q.145.006.292.006t.295-.006a11.992,11.992,0,0,1,4.9,1.164,1.1,1.1,0,0,0,.945-1.989Zm-5.873-1.378-.269,0-.266,0a5.285,5.285,0,1,1,.535,0Z" transform="translate(0)" fill="#fff"/>
                </g>
              </g>
              <g id="Group_9878" data-name="Group 9878" transform="translate(17.725 17.725)">
                <g id="Group_9877" data-name="Group 9877">
                  <path id="Path_8699" data-name="Path 8699" d="M331.358,326.128H328.33V323.1a1.1,1.1,0,0,0-2.2,0v3.028H323.1a1.1,1.1,0,0,0,0,2.2h3.028v3.028a1.1,1.1,0,0,0,2.2,0V328.33h3.028a1.1,1.1,0,0,0,0-2.2Z" transform="translate(-322 -322)" fill="#fff"/>
                </g>
              </g>
            </svg>
          </button>
        </div>
      </div>
    </div>
    <ModalUser/>
    <ModalAddUser/>
    <ModalDeleteUser @deleteEmployee="deleteEmployee(idSelect)"/>
    <ModalArchive @archive="archive(idSelect)"/>
  </div>
</template>
<script>
import {mapState} from 'vuex'
import { BModal, VBModal } from 'bootstrap-vue'
import Header from '@/components/share/Header.vue'
import ModalUser from '@/views/Manager/EmployeeManager/Edit'
import ModalAddUser from '@/views/Manager/EmployeeManager/Add'
import ModalDeleteUser from '@/views/Manager/EmployeeManager/Delete'
import {ROLE} from '../../../utils/constant'
import ModalArchive from '@/views/Manager/EmployeeManager/Archive'
export default {
  name: 'ListUser',
  data () {
    return {
      data: false,
      idSelect: null,
      paginations: {
        page_index: 1,
        sortBy: 'created_at',
        sortOrder: 'desc',
        perPage: 10,
        searchQuery: '',
        typingTimer: null,
        isTyping: false,
        statusQuery: 0
      }
    }
  },
  components: {
    Header,
    ModalUser,
    ModalAddUser,
    ModalDeleteUser,
    ModalArchive,
    'b-modal': BModal
  },
  directives: {
    // Note that Vue automatically prefixes directive names with `v-`
    'b-modal': VBModal
  },
  methods: {
    convertName (value) {
      if (value === 'employee') {
        return '社員'
      }
      if (value === 'manager') {
        return '管理者'
      }
    },
    editUser (id) {
      this.$root.$emit('bv::show::modal', 'modalEditUser', '#modalEditUser')
      this.$store.dispatch('employee/detailEmployee', {id: id})
    },
    showModalDelete (id) {
      this.idSelect = id
      this.$root.$emit('bv::show::modal', 'modalDeleteUser', '#modalDeleteUser')
    },
    deleteEmployee (id) {
      this.$store.dispatch(`employee/deleteEmployee`, {id})
      this.idSelect = null
    },
    showModalAdd () {
      this.$root.$emit('bv::show::modal', 'modalAddUser', '#modalAddUser')
    },
    detailUser (id) {
      this.idSelect = id
      this.$router.push(`/manager/employees/${id}`)
    },
    changePage (pageIndex) {
      this.paginations.page_index = pageIndex
      this.$store.dispatch('employee/listEmployee', this.paginations)
    },
    showAction (value) {
      return value === ROLE.EMPLOYEE
    },
    role (value) {
      return value === ROLE.MANAGER ? 'manager' : 'employee'
    },
    onSearch (keyword) {
      let vm = this
      vm.paginations.page_index = 1
      clearTimeout(vm.paginations.typingTimer)
      if (keyword === '') {
        vm.paginations.isTyping = false
        this.$store.dispatch('employee/listEmployee', vm.paginations); return
      }

      vm.paginations.typingTimer = setTimeout(() => {
        vm.$store.dispatch('employee/listEmployee', vm.paginations)
      }, 500)
    },
    filterDisplay () {
      let vm = this
      vm.paginations.isTyping = true
      vm.$store.dispatch('employee/listEmployee', vm.paginations)
    },
    archive (id) {
      this.$store.dispatch('employee/archiveEmployee', id)
      this.idSelect = null
      this.filterDisplay()
    },
    showmodalArchive (id) {
      this.idSelect = id
      this.$root.$emit('bv::show::modal', 'modalArchive', '#modalArchive')
    },
    setActive (id) {
      this.$store.dispatch('employee/unArchiveEmployee', id)
      this.idSelect = null
      this.filterDisplay()
    }
  },
  mounted () {
    this.$store.dispatch('employee/listEmployee', this.paginations)
  },
  computed: {
    ...mapState({
      users: state => state.employee.users,
      totalEmployee: state => state.employee.totalItems,
      totalPages: state => state.employee.totalPages,
      popup: state => state.employee.popup
    }),
    pageNumber () {
      const arr = []
      if (this.totalPages === 1) {
        return arr
      }
      const start = 1
      const end = this.totalPages
      const showPageCount = 6
      if (end <= showPageCount + 3) {
        for (let i = start; i <= end; i++) {
          arr.push({text: i, value: i})
        }
        return arr
      }
      arr.push({ text: start, value: start, show: '' })
      if (this.paginations.page_index >= 5) {
        arr.push({
          text: '...',
          value: '',
          show: 1
        })
      }
      let listStart = this.paginations.page_index - Math.floor(showPageCount / 2) + 1
      if (listStart <= 1) listStart = 2
      let listEnd = listStart + showPageCount - 1
      if (listEnd >= end) listEnd = end - 1
      listStart = listEnd - showPageCount + 1
      for (let i = listStart; i <= listEnd; i++) {
        arr.push({ text: i, value: i })
      }
      if (end - this.paginations.page_index >= showPageCount) {
        arr.push({
          text: '...',
          value: '',
          show: 2
        })
      }
      arr.push({ text: end, value: end, show: '' })
      arr.map((e, index) => {
        if (e.text === '...' && e.show === 2) {
          e.value = arr[index - 1].value + 1
        }
        if (e.text === '...' && e.show === 1) {
          e.value = arr[index + 1].value - 1
        }
        return e
      })
      return arr
    },
    hasPrev () {
      return (this.paginations.page_index === 1) ? 'page-item-disabled' : ''
    },
    hasPagination () {
      return this.pageNumber.length > 1
    },
    hasNext () {
      return this.paginations.page_index === this.totalPages ? 'page-item-disabled' : ''
    },
    showPage () {
      return this.totalPages > 1
    }
  }
}
</script>
<style scoped lang='scss'>
@import '@/assets/stylesheet/user/list_user.scss';
@import "@/assets/stylesheet/auth/listfile.scss";
</style>



// WEBPACK FOOTER //
// src/views/Manager/EmployeeManager/List.vue